import { render, staticRenderFns } from "./PollViewer.vue?vue&type=template&id=5f34177e&scoped=true"
import script from "./PollViewer.vue?vue&type=script&lang=js"
export * from "./PollViewer.vue?vue&type=script&lang=js"
import style0 from "./PollViewer.vue?vue&type=style&index=0&id=5f34177e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34177e",
  null
  
)

export default component.exports